import AccountPage from 'src/account';
import { AccountLayout } from 'src/components/layouts/account-layout';

AccountPage.layout = AccountLayout;
export default AccountPage;
